import { makeStyles } from '@material-ui/core/styles'

const WidgetFormTabStyles = makeStyles((theme) => ({
  selectedTab: {
    color: theme.palette.base.red,
  },
}))

export default WidgetFormTabStyles
